function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  'use strict';

  function initState($q, Resource) {
    var s = {};
    freshState();
    function freshState() {
      s.def = null;
      s.getInProgress = false;
      s._resource = new Resource('/filters', false, true);
    }
    function isGetInProgress() {
      return s.getInProgress;
    }
    function beginGet() {
      s.def = $q.defer();
      s.getInProgress = true;
    }
    function resolveGet(result) {
      s.def.resolve(result);
      s.getInProgress = false;
    }
    function rejectGet(alt) {
      return function () {
        resolveGet(alt);
      };
    }
    function getPromise() {
      if (typeof s.def !== 'undefined' && typeof s.def.promise !== 'undefined') {
        return s.def.promise;
      }
    }
    return [s, freshState, isGetInProgress, beginGet, resolveGet, rejectGet, getPromise];
  }
  angular.module('wsLrs.services').factory('CustomFilters', ['$http', '$q', 'Api', 'Resource', '$rootScope', function ($http, $q, Api, Resource, $rootScope) {
    var _initState = initState($q, Resource),
      _initState2 = _slicedToArray(_initState, 7),
      res = _initState2[0],
      freshState = _initState2[1],
      isGetInProgress = _initState2[2],
      beginGet = _initState2[3],
      resolveGet = _initState2[4],
      rejectGet = _initState2[5],
      getPromise = _initState2[6];
    $rootScope.$on('organization-selected', freshState);
    res.list = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          countReports: false
        },
        _limit = _ref._limit,
        _offset = _ref._offset,
        countReports = _ref.countReports,
        searchText = _ref.searchText,
        order_by = _ref.order_by;
      // don't start fetching, if there's already a fetch in progress
      if (!isGetInProgress()) {
        beginGet();
        res._resource.list({
          countReports: countReports,
          showHidden: true,
          searchText: searchText,
          order_by: order_by,
          _limit: _limit,
          _offset: _offset
        }).then(resolveGet, rejectGet([]));
      }
      return getPromise();
    };
    res.getAll = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          countReports: false,
          showHidden: true,
          ignoreReadPermissions: false
        },
        countReports = _ref2.countReports,
        showHidden = _ref2.showHidden,
        ignoreReadPermissions = _ref2.ignoreReadPermissions;
      // don't start fetching, if there's already a fetch in progress
      if (!isGetInProgress()) {
        beginGet();
        res._resource.getAll({
          countReports: countReports,
          showHidden: showHidden,
          ignoreReadPermissions: ignoreReadPermissions,
          order_by: 'name',
          _limit: 1000
        }).then(resolveGet, rejectGet([]));
      }
      return getPromise();
    };
    res.get = function (filterId) {
      // don't start fetching, if there's already a fetch in progress
      if (!isGetInProgress()) {
        beginGet();
        res._resource.get(filterId, {
          params: {
            returnReports: true,
            showHidden: true,
            order_by: 'name',
            _limit: 1000
          }
        }).then(resolveGet, rejectGet(undefined));
      }
      return getPromise();
    };
    res.save = function save(customFilter) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$override = _ref3.override,
        override = _ref3$override === void 0 ? true : _ref3$override;
      var filter = _.clone(customFilter);
      if (filter.id && !override) {
        delete filter.id;
        delete filter.created;
        delete filter.updated;
      }
      if (typeof filter.id === 'undefined' && _typeof(filter.config) !== undefined && typeof filter.config.id !== 'undefined') {
        delete filter.config.id;
      }
      if (filter.filterCategory && filter.filterCategory.id === null && filter.filterCategory.name === 'None') {
        delete filter.filterCategory;
      }
      return res._resource.save(filter);
    };
    return res;
  }]);
})();
